class TabSwitcher extends HTMLElement {
  constructor() {
    super();
    this.showTabContent = this.showTabContent.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.sliderInstance = null; // Store Flickity instance
  }

  connectedCallback() {
    this.initializeTabs();
  }

  initializeTabs() {
    this.tabHeadings = this.querySelectorAll(".tab-heading");
    this.tabContents = this.querySelectorAll(".tab_content");

    this.tabHeadings.forEach((heading) => {
      heading.addEventListener("click", this.handleTabClick);
    });

    const firstHeading = this.tabHeadings[0];
    if (firstHeading) {
      firstHeading.classList.add("active");
      this.showTabContent(firstHeading.dataset.target);
    }
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;
    this.tabHeadings.forEach((head) => head.classList.remove("active"));
    clickedTab.classList.add("active");

    const targetId = clickedTab.dataset.target;
    this.showTabContent(targetId);
  }

  showTabContent(targetId) {
    const activeContainer = document.createElement("div");
    activeContainer.classList.add("active-tabs-container");

    const inactiveContainer = document.createElement("div");
    inactiveContainer.classList.add("inactive-tabs-container", "hidden");

    this.tabContents.forEach((content) => {
      if (content.id === targetId.replace("#", "")) {
        content.classList.remove("hidden");
        content.classList.add("active");
        activeContainer.appendChild(content);
      } else {
        content.classList.add("hidden");
        content.classList.remove("active");
        inactiveContainer.appendChild(content);
      }
    });

    // Replace the current tabs-content container
    const tabsContent = this.querySelector(".tabs-content");
    tabsContent.innerHTML = ""; // Clear existing content
    tabsContent.appendChild(activeContainer);
    tabsContent.appendChild(inactiveContainer);

    this.initializeSlider(activeContainer); // Initialize Flickity for active tabs
  }

  initializeSlider(activeContainer) {
    if (this.sliderInstance) {
      this.sliderInstance.destroy();
      this.sliderInstance = null;
    }

    if (activeContainer) {
      // Check if there is more than one active tab_content inside the active container
      const activeTabContents = activeContainer.querySelectorAll('.tab_content.active');
      // Initialize Flickity only for the active container
      if (activeTabContents.length > 1) {
      this.sliderInstance = new Flickity(activeContainer, {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        draggable: false,
        lazyLoad: true,
        adaptiveHeight: true,
      });
      // Create custom navigation buttons
      const buttonsContainer = document.createElement('div');
      buttonsContainer.classList.add('flickity-buttons-container');
  
      // Create 'prev' button
      const prevButton = document.createElement('button');
      prevButton.classList.add('flickity-prev-button');
      prevButton.innerHTML = '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>';
      prevButton.addEventListener('click', () => {
        this.sliderInstance.previous();
      });
  
      // Create 'next' button
      const nextButton = document.createElement('button');
      nextButton.classList.add('flickity-next-button');
      nextButton.innerHTML = '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>';
      nextButton.addEventListener('click', () => {
        this.sliderInstance.next();
      });
  
      buttonsContainer.appendChild(prevButton);
      buttonsContainer.appendChild(nextButton);
  
      // Append the buttons container to the active container
      activeContainer.appendChild(buttonsContainer);
    }
    }
  }
}

customElements.define("tab-switcher", TabSwitcher);




